export default __webpack_public_path__ + "1934df699609d7ed7b880b18adc40152.jpg";